import { useSearchParams } from 'react-router-dom'

import { getAppInsights } from 'application-insights/TelemetryService'

import { Box, Button } from '@mui/material'

import { isBetaEnabled } from 'utils/helpers'

const ErrorSpitter = () => {
    const [searchParams] = useSearchParams()
    const error = searchParams.get('error')
    const appInsights = getAppInsights()

    const throwUnhandledClick = () => {
        throw new Error(`TST_${error}`)
    }

    const throwHandledClick = () => {
        try {
            throw new Error(`TST_${error}`)
        } catch (error) {
            appInsights.trackException({ exception: error })
            console.log(error)
        }
    }

    if (!isBetaEnabled()) {
        return null
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', position: 'absolute', top: '100px', left: '100px' }}>
            <Box sx={{ fontWeight: 600 }}>Error Spitter</Box>
            <Box>
                add message like this: <i>/error-spitter?error=Message</i>
            </Box>
            <Box sx={{ display: 'flex', gap: '8px' }}>
                <Button variant="contained" onClick={throwUnhandledClick}>
                    Throw unhandled error
                </Button>
                <Button variant="contained" onClick={throwHandledClick}>
                    Throw handled error
                </Button>
            </Box>
        </Box>
    )
}

export default ErrorSpitter
